/* Swubie buy-box add-on (snippets/swubie-buybox-addon.liquid).
   Ticking the box only changes the button total here; the actual add happens in swubie-lp.js,
   which sends the pack and the Tasjespakket (with _upsell) in one /cart/add.js request.
   The total is shown only where the button carries a price (data-cta-base, V2 product pages);
   the LP button says "Bestel nu" without a price, so nothing changes there. */
(function () {
  function cents(s) { var n = parseFloat(String(s || '').replace(/[^\d,]/g, '').replace(',', '.')); return isNaN(n) ? 0 : Math.round(n * 100); }
  function money(c) { return ((window.SwubieI18n || {}).moneyFormat || '€[amount]').replace('[amount]', (c / 100).toFixed(2).replace('.', ',')); }

  function init(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var cb = el.querySelector('.swb-addon__input');
    var root = el.closest('.shopify-section') || document;
    var btn = root.querySelector('.slp-offer__atc-btn');
    var addonPrice = parseInt(el.getAttribute('data-addon-price'), 10) || 0;
    if (!cb || !btn) return;

    function render() {
      var base = btn.getAttribute('data-cta-base');
      if (!base || btn.classList.contains('is-preorder')) return;
      var bundle = root.querySelector('.slp-bundle.selected') || root.querySelector('.slp-bundle');
      var label = btn.querySelector('.slp-offer__atc-label');
      if (!bundle || !label) return;
      var price = cents(bundle.getAttribute('data-price'));
      label.textContent = base + ' · ' + money(cb.checked ? price + addonPrice : price);
      /* the struck-through pack price next to a pack + bags total would be misleading */
      var was = btn.querySelector('.slp-offer__atc-was');
      if (was) was.style.display = cb.checked ? 'none' : '';
    }

    cb.addEventListener('change', render);
    root.querySelectorAll('.slp-bundle').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(render, 0); });
    });
  }

  function start() { document.querySelectorAll('[data-swb-addon]').forEach(init); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
